import React from "react";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import { CACHE_NOTIFY_CONFIG } from "src/constants/actionCache";
import ShowCacheFLFNotifyConfig from "../ShowCache/ShowCacheFLFNotifyConfig";
import FLFNotifyConfigPopup from "../Popup/FLFNotifyConfigPopup";

const FLFNotifyConfigControlPanel = ({
  children,
  currentActionCache,
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache Query Type"
          isShowButton={isShowCache(currentActionCache, CACHE_NOTIFY_CONFIG)}
        >
          <ShowCacheFLFNotifyConfig
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>

        <FLFNotifyConfigPopup
          recordForEdit={recordForEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          handleOpenPopup={handleOpenPopup}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </div>
    </div>
  );
};

export default FLFNotifyConfigControlPanel;
